<template>
  <li class="form-list-item">
    <slot/>
  </li>
</template>

<script>
export default {
  name: 'CFormListItem'
}
</script>

<style scoped>
.form-list-item {
  margin-bottom: 8px;
}
</style>
